import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { notification, Form, Input, Button } from "antd";
import useMediaQuery, { MediaQueryKey } from "use-media-antd-query";
import contactAnimation from "../../assets/img/contactAnimation.svg";
import consultationGif from "../../assets/img/consultation.gif";
import emailGif from "../../assets/img/email.gif";
import {
  FaRegAddressCard,
  FaMailBulk,
  FaHeadphones,
  FaFacebook,
  FaLink,
} from "react-icons/fa";
import { getAPIUrl } from "../../configs/global_var";

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

const Index = () => {
  const colSize = useMediaQuery();
  const [mobileView, setMobileView] = useState(colSize);
  const [inst, setInst] = useState({});

  useEffect(async () => {
    setMobileView(colSize);
    const infoInst = await getAPIUrl();
    console.log(infoInst[0]);
    setInst(infoInst[0]);
  }, [colSize]);

  const openNotification = (msg, status) => {
    const args = {
      message: msg,
      duration: 3,
      className: status ? "notif-succes" : "notif-faild",
    };
    notification.open(args);
  };

  const sendEmail = (e) => {
    // e.preventDefault();

    emailjs
      .send(
        "service_obth0eq",
        "template_3xecgiy",
        e,
        "user_wEc5ciB3HPoRsM3VpC0FQ"
      )
      .then(
        () => {
          openNotification("Berhasil mengirim pesan", true);
        },
        () => {
          openNotification("Gagal mengirim pesan", false);
        }
      );

    // e.preventDefault();

    // emailjs
    //   .sendForm(
    //     "service_obth0eq",
    //     "template_3xecgiy",
    //     e.target,
    //     "user_wEc5ciB3HPoRsM3VpC0FQ"
    //   )
    //   .then(
    //     (result) => {
    //       openNotification("Berhasil mengirim pesan", true);
    //     },
    //     (error) => {
    //       openNotification("Gagal mengirim pesan", false);
    //     }
    //   );
  };

  if (!inst.domain) {
    return null;
  }

  return (
    <main
      style={{
        display: "flex",
        justifyContent: "center",
        maxWidth: 1280,
        margin: "auto",
        marginTop: "10vh",
        flexWrap: "wrap",
      }}
    >
      {/* {mobileView !== "xs" && (
        <img src={contactAnimation} style={{ width: "30%" }} />
      )} */}
      <section style={{ maxWidth: "500px" }}>
        {inst.inst_email && (
          <div style={{ display: "flex", marginBottom: "14px" }}>
            <FaMailBulk style={{ fontSize: "28px" }} />
            <p style={{ marginLeft: "8px" }}>{inst.inst_email}</p>
          </div>
        )}

        {inst.phone1 && (
          <div style={{ display: "flex", marginBottom: "14px" }}>
            <FaHeadphones style={{ fontSize: "28px" }} />
            <p style={{ marginLeft: "6px" }}>{inst.phone1}</p>
          </div>
        )}

        {inst.phone2 && (
          <div style={{ display: "flex", marginBottom: "14px" }}>
            <FaHeadphones style={{ fontSize: "28px" }} />
            <p style={{ marginLeft: "6px" }}>{inst.phone2}</p>
          </div>
        )}

        {inst.address && (
          <div style={{ display: "flex", marginBottom: "14px" }}>
            <FaRegAddressCard style={{ fontSize: "28px" }} />
            <p style={{ marginLeft: "6px" }}>{inst.address}</p>
          </div>
        )}

        {inst.website_institute && (
          <div style={{ display: "flex", marginBottom: "14px" }}>
            <FaLink style={{ fontSize: "28px" }} />
            <p style={{ marginLeft: "6px" }}>{inst.website_institute}</p>
          </div>
        )}
        {/* <div style={{ display: "flex" }}>
          <img src={consultationGif} alt="consultation-gif" />
          <p style={{ marginLeft: "6px" }}>0812-1276-1988</p>
        </div>
        <div style={{ display: "flex" }}>
          <img src={consultationGif} alt="consultation-gif" />
          <p style={{ marginLeft: "6px" }}>0812-8750-5858</p>
        </div>
        <div style={{ display: "flex" }}>
          <img src={consultationGif} alt="consultation-gif" />
          <p style={{ marginLeft: "6px" }}>0859-2136-3223</p>
        </div> */}
      </section>
      <Form
        {...layout}
        name="nest-messages"
        validateMessages={validateMessages}
        style={{ width: mobileView === "xs" ? "80%" : "50%" }}
        onFinish={(e) => sendEmail(e)}
      >
        <Form.Item
          name={["user", "name"]}
          label="Nama"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={["user", "email"]}
          label="Email"
          rules={[
            {
              type: "email",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name={["user", "Message"]} label="Pesan">
          <Input.TextArea rows={5} />
        </Form.Item>
        <Form.Item
          style={{ justifyContent: "end" }}
          wrapperCol={{ ...layout.wrapperCol }}
        >
          <Button className="button-apply" htmlType="submit">
            <p style={{ color: "#fff" }}>Kirim</p>
          </Button>
        </Form.Item>
      </Form>
      {/* <form
        className="contact-form"
        onSubmit={sendEmail}
        style={{
          display: "flex",
          justifyContent: "center",
          alignSelf: "center",
        }}
      >
        <div
          style={{
            height: "80vh",
            width: "60vw",
            display: "flex",
            flexDirection: "column",
            // boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
          }}
        >
          <div className="col-6">
            <input
              className="effect-1"
              type="hidden"
              name="contact_number"
              required
            />
            <span className="focus-border" />
          </div>
          <div className="col-6">
            <label>Name</label>
            <input className="effect-1" type="text" name="user_name" required />
            <span className="focus-border" />
          </div>
          <div className="col-6">
            <label>Email</label>
            <input
              className="effect-1"
              type="email"
              name="user_email"
              required
            />
            <span className="focus-border" />
          </div>
          <div className="col-6">
            <label>message</label>
            <textarea className="effect-1" name="message" required />
            <span className="focus-border" />
          </div>
          <input
            type="submit"
            value="Send"
            style={{
              borderWidth: 0,
              width: "50vw",
              alignSelf: "center",
              backgroundColor: "#7367F0",
              color: "#FFF",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          />
        </div>
      </form> */}
    </main>
  );
};

export default Index;
